import { mapDirectusImage } from '../general';

export const mapDirectusVideoModal = (block: any): any => {
  return {
    anchor: block.anchor,
    video: mapDirectusImage(block.video),
    override: block.cdn_override,
  };
};
